import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_chat/chat/')({
  beforeLoad: () => {
    throw redirect({ to: '/chat/new' });
  },
});
